import React, { useEffect, useState } from 'react';
import { Branch } from './branch';
import { AppContext } from '../../App';
import { AdditionalRound } from './additional-round';
import { Arrow } from '../Svg/arrow';
// import { secondsInPast } from '../../Utils/time';
import { GAtrack } from '../../Utils/tracking';

import './tree.scss';

/**
 * sorts rounds by roundNr
 *
 * @param {*} a
 * @param {*} b
 */
const roundSort = (a, b) => {
  if (!a.roundNr || !b.roundNr || a.roundNr > b.roundNr) return 1;
  if (a.roundNr < b.roundNr) return -1;
  return 0;
};

/**
 * finds last finished heat in list of all rounds
 *
 * @param {*} data
 */
const findActive = (data, seconds) => {
  const checkData = [...data].reverse();

  for (let roundI = 0; roundI < checkData.length; roundI++) {
    const checkRound = [...checkData[roundI].heats].sort((a, b) => {
      const aTime = new Date(a.resultIsOfficialTimestamp).getTime();
      const bTime = new Date(b.resultIsOfficialTimestamp).getTime();

      return aTime < bTime ? 1 : aTime > bTime ? -1 : 0;
    });
    for (let heatI = 0; heatI < checkRound.length; heatI++) {
      if (
        checkRound[heatI].resultIsOfficial
        // && secondsInPast(new Date(checkRound[heatI].resultIsOfficialTimestamp), seconds)
      ) {
        return [checkData[roundI], checkRound[heatI]];
      }
    }
  }

  return [];
};

/**
 * splits heats of a round in branches
 * (2 heats = 1 branch)
 *
 * @param {*} data
 */
const splitBranches = (data) => {
  const branches = [];
  let arrIndex = -1;
  for (let i = 0; i < data.length; i++) {
    if (i % 2 === 0) {
      arrIndex++;

      branches[arrIndex] = [];
    }

    branches[arrIndex].push(data[i]);
  }

  return branches;
};

/**
 * replaces headline if there is a replacement in config
 *
 * @param {string} headline
 */
const prepareHeadline = (headline) => {
  return (
    <AppContext.Consumer>
      {({ config }) => {
        return config && config.replacements && config.replacements[headline]
          ? config.replacements[headline]
          : headline;
      }}
    </AppContext.Consumer>
  );
};

/**
 * Builds the tree view for knockout round
 *
 * @param {{data: *, setHeat: Function, activeHeat: *, category: string}} param0
 */
const Tree = ({ data, setHeat, activeHeat, category, config }) => {
  // sort rounds to be sure they are in correct order
  data.sort(roundSort);

  // get last 4 rounds
  const filteredData = data.slice(-4);
  // receive 5th from end for additional slidein tree
  const additionalRound = data.length > 4 ? data.slice(-5, 1)[0] : undefined;

  const [round, setRound] = useState();
  const [additionalDisabled, setAdditionalDisabled] = useState(true);

  /**
   * reset view if new category is received
   */
  useEffect(() => {
    const activeData = findActive(data, config.delayDataSeconds || 60);

    if (!activeHeat) {
      setAdditionalDisabled(true);
    }

    if (activeData.length) {
      setRound(activeData[0]);
      setHeat(activeData[1]);
    } else if (filteredData && filteredData[0]) {
      setRound(filteredData[0]);
      if (!activeHeat) {
        setHeat(filteredData[0].heats[0]);
      }
    }
    // eslint-disable-next-line
  }, [data]);

  return (
    <>
      <div className="knockOutTree appRow">
        <div className="knockOutTree_wrapper">
          {additionalRound && (
            <AdditionalRound
              {...additionalRound}
              setHeat={setHeat}
              activeHeat={activeHeat}
              disabled={additionalDisabled}
              isActiveRound={round && additionalRound.roundNr === round.roundNr}
            />
          )}
          <div className="knockoutTree_treeWrapper">
            <div className="knockOutTree_head">
              {filteredData &&
                filteredData.map(({ roundNr, name }, index) => (
                  <div className="round" key={`round-${roundNr}`}>
                    <h4
                      className={`h4${
                        (round && roundNr === round.roundNr) || (!round && index === 0)
                          ? ' textActive'
                          : ''
                      }`}
                    >
                      {prepareHeadline(name)}
                    </h4>
                  </div>
                ))}
            </div>
            <div className={`knockOutTree_tree rounds-${filteredData.length}`}>
              {filteredData &&
                filteredData.map(({ roundNr, name, heats }, index) => {
                  const branches = splitBranches(heats);
                  return (
                    <div className="round" key={`round-${roundNr}`}>
                      <div className="branches">
                        {branches &&
                          branches.map((branch, bindex) => (
                            <Branch
                              key={`branch-${index}${bindex}`}
                              branch={branch}
                              setHeat={setHeat}
                              activeHeat={activeHeat}
                              category={category}
                              config={config}
                            />
                          ))}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="knockOutTree-interactionbar">
          {additionalRound && filteredData && (
            <div
              className={`knockOutTree_slideLeft`}
              onClick={() => {
                const dataLayerArgs = {
                  // dataLayer: {
                  event: 'rbVideoTracking',
                  event_name: 'video_sidebar',
                  video_sidebar: {
                    value: `${category}::${additionalDisabled ? 'Top64' : 'Finals'}`,
                    widget_type: `Knockout Tree - ${
                      config.trackingTitle || config.navigationTitle
                    }`
                  }
                  // eventCategory: 'video',
                  // eventAction: 'sidebar',
                  // }
                };

                GAtrack(dataLayerArgs);

                setAdditionalDisabled(!additionalDisabled);
              }}
            >
              <>
                <Arrow
                  style={{
                    transform: `${additionalDisabled ? 'rotate(0deg)' : 'rotate(180deg)'}`
                  }}
                />
              </>
              {additionalDisabled ? (
                <>{prepareHeadline(additionalRound.name)}</>
              ) : (
                <>{prepareHeadline('Finals')}</>
              )}
            </div>
          )}
          <ul className="knockOutTree-legend appRow">
            <li>
              {config.finishedText || 'Finished'}{' '}
              <span className="knockOutTree-legend-bubble finished"></span>
            </li>
            <li>
              {config.upcomingText || 'Upcoming'}{' '}
              <span className="knockOutTree-legend-bubble"></span>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export { Tree, prepareHeadline };
